var classes = {"navigationItem":"ryxOA","navigationItemUnselected":"A1V04","navigationItemSelectedDefault":"_9rbKG","navigationItemDefault":"-sVSh","navigationItemUniversal":"XUpJy","navigationItemSelectedUniversal":"jBeTl"};

export { classes as default };
